import React, { Component } from 'react';
import store from '@/store/index';
import { ActionSheet, Toast, Button } from 'antd-mobile';
import { ApiGetInviteCodeByCustId } from '@/api/';
import { country2Money } from './config';
import {
  sendSms,
  sendMail,
  openWhatsapp,
  openMessenger,
  openTwitter,
  openInstagram,
  $t,
  getArray2Name,
  AppList,
  getQueryVariable,
  copyToClip,
  sensorsMonitor,
  getProxyConfig,
} from '@/utils/utils';

const SaSdk = sensorsMonitor();
class InviteFriends extends Component {
  constructor(props) {
    super(props);

    let localApp = (props.match.params.app || 'xcredit').toLowerCase();
    let custId = getQueryVariable('custId');

    let app = getArray2Name(AppList, localApp);
    if (!app) {
      app = AppList[0]; // 默认走印度
    }
    // 设置多语言key
    store.dispatch({ type: 'set-i18n', data: app.i18n || 'en_US' })

    // 当前国家对应邀请好友得到的钱(默认尼日)
    const localMoney = country2Money[app.country] || country2Money['尼日利亚'];

    this.state = {
      applicationId: '',
      localApp,
      localMoney,
      appRules: app, // 当前app相关配置
      custId,
      inviteCode: '',
      canShare: false,
    }
  }

  dataList = [
    { url: 'message.webp', title: '短信', label: 'Message' },
    { url: 'mail.webp', title: 'email', label: 'Mail' },
    { url: 'whatsapp.webp', title: 'WhatsApp', label: 'WhatsApp' },
    { url: 'messenger.webp', title: 'Messenger', label: 'Messenger' },
    { url: 'twitter.webp', title: 'Twitter', label: 'Twitter', },
    { url: 'instagram.webp', title: 'Instagram', label: 'Instagram' },
  ].map(obj => ({
    icon: <img src={ `${ window.$localCdnLink }/icon/${ obj.url }` }
      alt={obj.title}
    />,
    title: obj.label,
  }));

  showShareActionSheet = () => {
    // 仅需记录点击分享操作 无需记录分享到哪个平台
    SaSdk.track('h5_invitefriends_click');

    ActionSheet.showShareActionSheetWithOptions({
      className: 'mib-action-sheet',
      options: this.dataList,
      message: $t('inviteFriends'),
      cancelButtonText: $t('cancel')
    },
    (buttonIndex) => {
      if (buttonIndex < 0) return

      const key = this.dataList[buttonIndex].title;
      const Content = this.getSmsContent();
      copyToClip(Content); // 复制内容

      Toast.info($t('openingApp'), 2);
      switch (key) {
        case 'Message':
          sendSms('', Content);
          break;
        case 'Mail':
          sendMail('', Content);
          break;
        case 'WhatsApp':
          openWhatsapp('', Content);
          break;
        case 'Messenger':
          openMessenger(Content);
          break;
        case 'Twitter':
          openTwitter('', Content);
          break;
        case 'Instagram':
          openInstagram(Content);
          break;
        default:
          break;
      }
    });
  }

  getSmsContent () {
    const { inviteCode, localApp } = this.state;
    const registerLink = `${ window.location.origin }/h5/register/${ localApp }?inviteCode=${ inviteCode }`

    return `Come and enjoy the loan service with me! Invitation code：${inviteCode},Open link:${ registerLink }`
  }

  getCode () {
    this.setState({ canShare: false });

    const { custId, localApp } = this.state;
    if (!custId) {
      Toast.fail($t('plzCheckUid'), 4);
      return
    }

    const { header, params } = this.state.appRules;
    let iv = '';
    ApiGetInviteCodeByCustId({
      headers: header,
      data: { ...params, custId },
      ...getProxyConfig(localApp),
    }).then(res => {
      // 会存在id不存在 但是code===0000返回值为{}的情况
      if (typeof res === 'string') {
        this.setState({ canShare: true });
        iv = res || ''
      }
    }).finally(() => {
      this.setState({
        inviteCode: iv,
      })
    })
  }

  // 数据打点相关
  sensorsInit() {
    SaSdk.registerPage({
      current_url: window.location.href,
      pagename: 'h5_invitefriends',
      appName: this.state.appRules.appName,
    })

    SaSdk.quick('autoTrack');
    SaSdk.track('h5_invitefriends_open');
  }

  componentDidMount() {
    this.sensorsInit();
    this.getCode();
  }

  render() {
    // 这里的钱是按照国家划分的
    const money = this.state.localMoney
    const Bonus1 = money.register + money.info + money.apply + money.pay + money.payOff;
    const Bonus2 = Bonus1 + money.friend;

    // 计算字符串
    const m1 = `${ money.register } + ${ money.info } + ${ money.apply } + ${ money.pay } + ${ money.payOff }`;
    // 各个对应值
    const m2 = `(${ money.unit }${ money.register })`;
    const m3 = `(${ money.unit }${ money.info })`;
    const m4 = `(${ money.unit }${ money.apply })`;
    const m5 = `(${ money.unit }${ money.pay })`;
    const m6 = `(${ money.unit }${ money.payOff })`;
    const m7 = `(${ money.unit }${ Bonus1 })`;
    const m8 = `(${ money.unit }${ money.friend })`;
    const m9 = `(${ money.unit }${ Bonus2 })`;

    const { localApp } = this.state;
    const appClass = 'invite-friends page ' + localApp;

    const urlRoot = window.$localCdnLink + '/app/' + localApp + '/invite/';
    return <div className={ appClass }>
        <div className={ 'flexBox flexCenter img80Full' }>
          <img src={ urlRoot + 'title.webp' }  alt=""/>
        </div>
        <div className={ 'flexBox flexCenter imgFull' }>
          <img src={ urlRoot + 'bg.webp' }  alt=""/>
        </div>
        <div className='whitePanel'>
          <div className='whiteContent'>
            <div className='whitePanelTitle'>
              <div className='flexBox flexCenter flexVerticalCenter panelTitleFont fontRobotoFamily'>
                Bonus 1
              </div>
              <div className='fontSize12 fontGrey titleIntroduction'>
                Invite friend and get cash!
              </div>
            </div>
            <div className='flexBox flexCenter imgFull bonusImg1'>
              <img src={ urlRoot + 'group.webp' } alt=""/>
            </div>
            <div className='fontSize12 fontGrey titleIntroduction'>
              <span className='fontRed'>*</span>For example: Your friends paid off the loan, you can get cash { m1 }=<span className='fontGreen'>{ Bonus1 }</span>!
            </div>
            <div className='whitePanelTitle'>
                <div className='flexBox flexCenter flexVerticalCenter panelTitleFont fontRobotoFamily'>
                Bonus 2
              </div>
              <div className='fontSize12 fontGrey titleIntroduction'>
                Become an agent!
              </div>
            </div>
            <div className='flexBox flexCenter imgFull bonusImg2'>
              <img src={ urlRoot +'invite.webp' }  alt=""/>
            </div>
          </div>
          <div className='whitePanel'>
            <div className='whiteContent'>
              <div className='whitePanelTitle'>
                <div className='flexBox flexCenter flexVerticalCenter panelTitleFont fontRobotoFamily'>
                  Rule description
                </div>
              </div>
              <div className='fontSize12 fontGrey'>
                <div className='introductionGroupBox'>
                  <div className='fontSize14 fontBlack fontRobotoFamily introductionGroupItem titleRuleIntroduction'>
                    Bonus 1
                  </div>
                  <div>
                    1.Invited users successfully register <span className='fontSize12 fontGreen'>{ m2 }</span>
                  </div>
                  <div>
                    2.Fill in the information <span className='fontSize12 fontGreen'>{ m3 }</span>
                  </div>
                  <div>
                    3.Apply for a loan <span className='fontSize12 fontGreen'>{ m4 }</span>
                  </div>
                  <div>
                    4.Get the cash reward after <span className='fontSize12 fontGreen'>{ m5 }</span> successful disbusement
                  </div>
                  <div>
                    5.Get the cash reward <span className='fontSize12 fontGreen'>{ m6 }</span> after successful repayment
                  </div>
                    <div className='fontSize14 fontBlack fontRobotoFamily titleRuleIntroduction'>
                      Bonus 2
                    </div>
                    <div>
                      1.Your friends invite others, you will also get rewards!
                    </div>
                    <div>
                      2.You-invite 1 friend-your friend invite 1friend
                    </div>
                    <div>
                      3.You invite a friend to get the loan, you can get <span className='fontSize12 fontGreen'>{ m7 }</span>
                    </div>
                    <div>
                      4.Your friend invite a friend to get the loan, you also get <span className='fontSize12 fontGreen'>{ m8 }</span>
                    </div>
                    <div>
                      5.If you invite a friend and your friend also invites a friend, you can get <span className='fontSize12 fontGreen'>{ m9 }</span> at most.
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Button
          type="primary"
          onClick={this.showShareActionSheet}
          className='flexBox flexCenter flexVerticalCenter fontInvite fontRobotoFamily inviteButton'
          disabled={ !this.state.canShare }
        >
          INVITE NOW
        </Button>
    </div>
  }
}

export default InviteFriends;
